// extracted by mini-css-extract-plugin
export default {"root":"root--g8uMA","body2":"body2--Ll3Ys","seperator":"seperator--T_sv3"};